<template>
  <!--水源地表单-->
  <div class="otherBox">
    <el-form ref="formlist" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="水源地全称" prop="name">
        <el-input v-model="form.name" style="width:400px" placeholder="水源地全称"></el-input>
      </el-form-item>
      <el-form-item label="水源地地址" prop="address">
        <dataTree @change='changeId' :defaultData='defaultPointerData'></dataTree>
        <el-input v-model="form.address" style="width:400px;display:block;margin-top:22px" placeholder="街道详细地址"></el-input>
      </el-form-item>
      <el-form-item label="保护级别" label-width="120px" prop="subType">
        <el-select v-model="form.subType" placeholder="请选择">
          <el-option v-for="item in subTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" label-width="120px" prop="linkMan">
        <el-input v-model="form.linkMan" placeholder="联系人" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" label-width="120px" prop="phone">
        <el-input v-model="form.phone" placeholder="联系电话" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="中心坐标" label-width="120px" prop="latitude">
        <el-button @click="showMap.state = true">地图选点</el-button>
        <span style="margin-left: 5px">东经：{{form.longitude | formatDegree}}，北纬：{{form.latitude | formatDegree}}</span>
<!--        <el-input style="width:150px" v-model.number="form.longitude" placeholder="经度"></el-input>-->
<!--        <el-input style="width:150px" v-model.number="form.latitude" placeholder="纬度"></el-input>-->
        <mapPointer :show="showMap" :source='{lat:form.latitude,lng:form.longitude}'  @change="confirm"></mapPointer>
      </el-form-item>
      <el-form-item label="所属区划">
        <scaleRegion ref="scaleRegiondata" @change="changeRegion" @changeIdval="changeRegionId" :isUpdata='isUpdata' :defaultObj='defaultObj'></scaleRegion>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import scaleRegion from '../../components/region/ScaleRegion'
import mapPointer from '../../view/component/MapPointer.vue'
import dataTree from '../../view/component/Datatree.vue'
import account from '../../data/basic/plan/company.js'
import { mapState } from 'vuex'
export default {
  components: {
    mapPointer,
    dataTree,
    scaleRegion
  },
  data() {
    return {
      defaultObj: {},
      showMap: {
        state: false
      },
      latlng: {
        lat: '',
        lng: ''
      },
      // 验证
      rules: {
        name: [{
          required: true,
          message: '请输入水源地全称的名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入街道详细地址',
          trigger: 'blur'
        }],
        linkMan: [{
          required: true,
          message: '请输入联系人的名称',
          trigger: 'blur'
        }],
        phone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            pattern: /^1\d{10}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        subType: [{
          type: 'number',
          required: true,
          message: '请选择保护级别',
          trigger: 'change'
        }],
        zoning: [{
          required: true,
          message: '请选择市',
          trigger: 'change'
        }],
        latitude: [{
          type: 'number',
          required: true,
          message: '请选择地图坐标',
          trigger: 'change'
        }],
        regions: [{

          required: true,
          message: '所属区划不能为空',
          trigger: 'change'
        }]
      },
      form: {
        address: '', // 地址
        city: '', // 市代码 ,
        cityName: '', // 市名称 ,
        count: '', // 成员数量 ,
        county: '', // 县代码 ,
        countyName: '', // 区/县名称 ,
        createtime: '', // 创建时间 ,
        id: '',
        latitude: '', // 纬度 ,
        longitude: '', // 经度 ,
        name: '', // 机构名称 ,
        phone: '', // 电话 ,
        province: '', // 省代码 ,
        provinceName: '', // 省名称 ,
        regionType: 1,
        regions: [], // 区划 ,
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        subType: '',
        type: '',
        linkMan: '',
      },
      defaultPointerData: [],
      subTypeArr: [{
          value: 1,
          label: '一级保护区'
        },
        {
          value: 2,
          label: '二级保护区'
        },
        {
          value: 3,
          label: '准保护区'
        }
      ],
      //区域检验结果
      validRegion:false,
    }
  },
  mounted() {
    // 初始化区县列表
    this.getCountyList()
  },
  props: {
    modifyenf: {
      type: Object
    },
    isUpdata: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      dataWtlist(state) {
        return state.dataWtlist
      },
    })
  },
  created() {
    if (this.isUpdata) {
      if (!this.dataWtlist) {
        // console.log(this.isUpdata)
        this.$router.replace('/')
      } else {
        this.form = JSON.parse(JSON.stringify(this.dataWtlist))
        this.defaultPointerData = [this.form.province, this.form.city, this.form.county]

        if (this.dataWtlist.regionType === 3) {
          this.defaultObj = {
            regionType: this.dataWtlist.regionType,
            regions: this.dataWtlist.regions
          }
        } else {
          this.defaultObj = {
            city: this.dataWtlist.regions[0].city,
            county: this.dataWtlist.regions[0].county,
            regionType: this.dataWtlist.regionType
          }
        }
      }
    }
  },
  methods: {
    // 数据的类型
    changeRegionId(val) {
      this.form.regionType = val
    },
    // 获取所属区划数据
    changeRegion(data) {
      this.form.regions = data
      if (this.form.regionType === 3) {
        if (this.form.regions && this.form.regions.length > 1) {
          if (this.form.regions && this.form.regions.length >= 2 && this.form.regions[1].city.code === '') {
            this.$message.error('跨市类型必须输入2条及以上信息')
            this.validRegion = false;
            return;
          }
        } else {
          this.$message.error('跨市类型必须输入2条及以上信息')
          this.validRegion = false;
          return;
        }
      } else {
        if (this.form.regions && this.form.regions[0].city.code === '') {
          this.$message.error('单个区县类型不能为空')
          this.validRegion = false;
          return
        }
      }
      this.validRegion = true;
    },
    // 提交验证
    onSubmitwtf(formName) {
      this.$refs['scaleRegiondata'].get_datalist()
      if(this.validRegion){
        this.$refs['formlist'].validate((valid) => {
          if (valid) {
            this.$emit('change', this.form)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 取消输入的
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 经纬度
    mapclick(val) {
      let lat = val.latlng.lat,
        lng = val.latlng.lng
      this.latlng.lat = lat
      this.latlng.lng = lng
    },
    // 执行确认操作
    confirm(val) {
      this.form.latitude = Math.floor(val.lat * 1000000) / 1000000
      this.form.longitude = Math.floor(val.lng * 1000000) / 1000000
    },
    // 执行取消或者关闭
    cancel(val) {
      this.showMap.state = val
    },
    // 获取区县列表
    getCountyList() {
      (async() => {
        this.statelist = await account.get_tree()
        this.pro = this.statelist;
        this.city = this.pro[0]['children'];
        this.county = this.city[0]['children'];
      })()
    },
    changeId(val) {
      if (val.length === 2) {
        this.form.county = ''
        this.form.city = val[1]
        this.form.province = val[0]
      } else {
        this.form.county = val[2]
        this.form.city = val[1]
        this.form.province = val[0]
      }
    },
  }
}

</script>
<style lang="stylus" scoped>
.otherBox {
  clear: both;
  padding-bottom: 20px;
}

.address-p1 {
  display: block;
  width: 400px;
}

.address-p2 {
  display: block;
  width: 400px;
}

.input-w180 {
  width: 180px;
}

.input-w140 {
  width: 140px;
}

.input-w150 {
  width: 140px;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// Wtform.vue?52f0bf34